export enum ResCode {
  Success = '000',
  TokenInvalid = 101421,
}

export const HTTP_STATUS: { [key: string]: number } = {
  SUCCESS: 200,
  CREATED: 201,
  ACCEPTED: 202,
  CLIENT_ERROR: 400,
  AUTHENTICATE: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
}

export const ERROR_STATUS: { [key: string]: string } = {
  // 用户中心
  // 100000: '请求正常结束',
  100001: '系统内部异常',
  100002: '未鉴权',
  100003: '请求异常', // 一般都是参数不正确的提示
  100004: '结果未找到',
  100005: '无权限操作',

  2005021: '您的操作太频繁，请稍后再试',

  302009: '棋手信息不正确',

  601401: '用户信息不正确',
  601402: '棋手信息不正确',
  601403: '设备信息不正确',
  601404: '功能类型不正确', // （只有在新人指引里面会报）
  601405: '群组信息不正确',

  601411: '重复棋手名字',
  601412: '重复绑定设备',
  601413: '人脸id重复',
  601414: '重复用户', //（后台没有使用）
  601415: '管理员已存在', // （这个未来应该不会用到了）
  601416: '无法绑定设备',
  601417: '设备已被绑定',
  601418: '棋手已加入当前组', //（重复邀请）
  601419: '超出群组内棋手数量上限',
  601420: '超出个人群组数量上限',
  601421: '当群组只剩一个管理员时无法删除管理员',
  601422: '当群组只剩下一个管理员时不允许将管理员设置为普通棋手',
  601423: '没有绑定微信的棋手不允许设置为管理员',
  601424: '不允许修改绑定了微信的棋手的基本信息', // （名称、头像、人脸id）
  601425: '不能离开自己的默认组', // （名称、头像、人脸id）
  601501: '棋手名称不能超过12个字符',
  601502: '群组名称不能超过20个字符',
  601526: '已绑定设备的群组不能删除',

  // 评测
  // 100000: '成功',
  // 500: 'fail',
  801004: '请求参数错误',

  801001: '无效的请求方法',
  801002: '无效的人脸图片',
  801003: '无相关的报名信息',

  802001: '报名失败',
  802002: '存在已报名未评测的记录',
  802003: '身份证号码非法',
  802004: '非注册棋手，不能评测',
  802005: '未完成课程学习，不具备该级别评测资质',
  802006: '上传评测结果失败',
  802007: '无相关的评测信息',
  802008: '添加评测信息失败',
  802009: '考生和报名人不是同一个人',
  802010: '此项报名信息已完成评测或未完成支付',
  802011: '无效的FEN串',

  803001: '无相关的证书',
  803002: '无效的证书号码',
  803003: '此身份信息已经获得此级别证书，不能重复评测',
  803006: '申请人ID和证书号不能同时为空',

  // 设备link
  700001: '无效的请求参数',
  700002: '设备名称过长',
  700202: '不存在设备',
  700205: 'mqtt消息推送失败',
  700212: '图像检查失败',
  700901: '图片解析失败',
  700902: '参数错误',
  700903: '服务不可用',
  700904: '未检测到人脸',
  700905: '检测到多个人脸',
  700906: '人脸检测失败',
  700907: '人脸验证失败',
  700908: '图片解码失败',
  700909: '质量检测未通过',
  700910: '模型版本不支持',
  700911: '服务内部错误',
  700912: '特征服务未认证错误',
  700913: '证书内容不合法',
  700914: '证书过期',
  700915: '证书激活码错误',
  700916: '模型已存在',
  700917: '获取不到cpu id',
  700918: '获取不到uuid',

  // 201001: '人脸检测失败',
  // 701498: '参数有误',
  // 701610: '记录已存在',
  // // /sl/v2/facade/checkavatarused接口错误码
  // 80201: '检测到多张脸',
  // 80202: '图像大小太小',
  // 80203: '对齐分数太低',
  // 80214: '面部面积太小',
  // 80204: '俯仰角太大',
  // 80205: '偏航角太大',
  // 80206: '滚动角度太大',
  // 80207: '面部离图像中心太远',
  // 80208: '面部比例太低',
  // 80209: '面部闭塞',
  // 80210: '图像太暗或太亮',
  // 80211: '图像太模糊了',
  // 80212: '嘴巴张得太大了',
  // 80213: '面部缺失太多啦',
  // 99999: '未知错误',
  // 80101: '图像分析失败',
  // 80102: '参数非法',
  // 80103: '找不到服务',
  // 80104: '未检测到人脸',
  // 80105: '检测到多个人脸',
  // 80106: '人脸检测失败',
  // 80107: '人脸验证失败',
  // 80108: '图像解码失败',
  // 80109: '质量检测未通过',
  // 80110: '模型版本不存在',
  // 80111: '特征内部误差',
  // 80112: '需要执照',
  // 80113: '特征许可无效',
  // 80114: '特征许可过期',
  // 80115: '特征激活代码无效',
  // 80116: '特征模型版本存在',

  //订单支付
  900001: '无此优惠券',
  900002: '优惠券领取失败',
  900003: '创建订单失败',
  900004: '商品不存在',
  900005: '优惠券已过期',
  900006: '订单无效',
  900007: '订单已支付',
  900008: '退款金额不匹配',
  900010: '优惠券不能为空',
  900011: '无效的优惠券',
  900012: '优惠券不可用',
  900013: '优惠券与订单金额不匹配',
  900014: '商品不存在',
  900015: '支付金额不匹配',
  900016: '微信创建订单失败',
  900017: '微信关闭订单错误',
  900018: '更新订单状态失败',
  900019: '微信签名失败',
  900020: '微信请求失败',
  900021: '用户订单不存在',
  900022: '用户id无效',
  900023: '订单已关闭',
  900024: '订单取消失败',
  900025: '设备id有误',
  900026: '优惠卷删除失败',
  900027: '优惠卷更新失败',
  900028: '优惠卷已使用',
  900029: '商品已购买',
  900030: '存在为支付的订单',

  2005016: '无效的code~',

  [ResCode.TokenInvalid]: '登录已失效',
}
